import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { PageHeader } from '../../components'
import axios from 'axios'
import routes from '../../routes/routes'

const HallBookingRes = () => {
    const [showInput, setShowInput]= useState('none');
    const [result, setResult]= useState('');
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [hallType, setHallType] = useState('');
    const [startDate, setStartDate] = useState('');
    const [guestnum, setGuestnum] = useState('');
    const [status, setStatus] = useState('');
    const [purpose, setPurpose]=useState('');
    const [phone, setPhone] = useState('');
    const [memberId, setMemberId] =useState('');
    const booking = {
        name: name,
        phone:phone,
        address: address,
        hallType: hallType,
        event_start_date:startDate,
        guestnum:guestnum,
        memberId:memberId,
        status:status,
        purpose:purpose
    }
    const localhost = "https://test.lagoscountryclub.net/api/addBooking"
    const header = {
        'Accept':"application/json",
        'Content-Type': 'application/json',
    }
    
const hallBooking = () =>{
    console.log('boking details is '+booking)
    fetch("https://test.lagoscountryclub.net/api/addBooking",{
        method:"Post",
        body: JSON.stringify(booking),
        headers: header,
    }).then((response)=>{
        response.json().then((res)=>{
            // console.log(res.message);
            if(res.message==='success'){
                setResult('Booking done successfully');
                setName('');
                setAddress('');
                setHallType('');
                setStartDate('');
                setGuestnum('');
                setStatus('');
                setPurpose('');
                setPhone('');
                setMemberId('');
            }
        })
    })
}
    return (
        <div className='page-content'>
            <PageHeader title="Hall Booking" page="hallbooking" />
            <div className='container'>
                <div className='row'>
                <h2>Book Hall</h2>
                    <div className='col-md-8 p-a30 bg-gray clearfix m-b30 '>
                        <div className=' p-5'>
                            {result && 
                                    <div className='bg-success w-100 ' style={{padding:'2%', color:'white'}}>
                                    {result} 
                                    </div> 
                            }
                    <form className='form card p-5 border'>
                        <div className='row form-group'>
                            <div className='col-sm-6 '>
                            <label htmlFor="name">Full name</label>
                                <input value={name} onChange={e =>{setName(e.target.value)}} type='text' id='name' name='name' className='form-control' />
                            </div>
                            <div className='col-sm-6 '>
                            <label htmlFor="address">Address</label>
                                <input value={address} onChange={e =>{setAddress(e.target.value); 
                                    }} type='text' id='address' name='address' className='form-control'/>
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col-sm-6 '>
                                <label htmlFor="purpose">Purpose of Use</label>
                                <input type='text' value={purpose} onChange={e=>{setPurpose(e.target.value)}} id='purpose' name='purpose' className='form-control'/>
                            </div>
                            <div className='col-sm-6 '>
                                <label htmlFor="phone">Phone Number</label>
                                <input type='text' value={phone} id='phone' onChange={e=>{setPhone(e.target.value)}} name='phone' className='form-control'/>
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col-sm-6'>
                                <p>Your Status</p>
                                <div className='row form-group'>
                                    <div className='col-sm-6 '>
                                        <label>Member</label>
                                        <input value={status} type='radio' onClick={e=>{setStatus(e.target.value); setShowInput('block')}} id='status' name='status' className='form-control' value='member'/>
                                        <input value={memberId} className='form-control' type='text' style={{display:showInput}}  placeholder='Member ID' onChange={e=>{setMemberId(e.target.value)}}/>
                                    </div>
                                    <div className='col-sm-6 '>
                                        <label htmlFor="phone">Non-Member</label>
                                        <input value={status} type='radio' onClick={e=>{setStatus(e.target.value); setShowInput('none');setMemberId('nam')}} id='status' name='status' className='form-control' value='non-member'/>
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-6'>
                                <p>Select Hall Type</p>
                                <div className='row form-group'>
                                    <div className='col-sm-6 '>
                                        <label>Diamond Hall</label>
                                        <input value={hallType} type='radio' onClick={e=>{setHallType(e.target.value)}} id='halltype' name='halltype' className='form-control' value='diamond'/>
                                    </div>
                                    <div className='col-sm-6 '>
                                        <label htmlFor="phone">Little Theatre</label>
                                        <input value={hallType} type='radio' onClick={e=>{setHallType(e.target.value)}} id='halltype' name='halltype' className='form-control' value='little theatre'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className='row'>
                            {/* <div className='col-sm-4 form-group'> */}
                                {/* <label htmlFor="hallType">HallType</label>
                                <select onChange={e =>{setHallType(e.target.value);}} id='hallType' name='hallType' placeholder='Select Hall' className='form-control' >
                                    <option value='small'>Small NGN 300,000</option>
                                    <option value='large'>Large NGN 700,000</option>
                                </select> */}
                                {/* <input onChange={e =>{setHallType(e.target.value); console.log(hallType);}} id='hallType' name='hallType' placeholder='Select Hall' className='form-control' /> */}
                            {/* </div> */}
                            <div className='col-sm-6 form-group'>
                            <label htmlFor="eventDate">Event Date</label>
                                <input value={startDate} onChange={e =>{setStartDate(e.target.value)}} type='date' id='eventDate' name='eventDate' className='form-control'/>
                            </div>
                            <div className='col-sm-6 form-group'>
                            <label htmlFor="guestnum">Number of Expected Guest</label>
                                <input value={guestnum} onChange={e =>{setGuestnum(e.target.value)}} type='number' id='guestnum' name='guestnum' className='form-control'/>
                            </div>
                        </div>
                        <div>
                            <button type='button' onClick={hallBooking} aria-pressed="true" className='site-button'>Book Hall</button>
                        </div>
                    </form>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <h2>Booking Conditions</h2>
                        <div>
                        <table className="table table-striped">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Day</th>
      <th scope="col">Diamon Hall</th>
      <th scope="col">Little Theatre</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td>MON to WED</td>
      <td>N350,000.00 </td>
      <td>200,000 (Members)<br/>300,000 (non-members) </td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td>THU to FRI</td>
      <td>N450,000.00 </td>
      <td>200,000 (Members)<br/>300,000 (non-members) </td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>SAT</td>
      <td>450,000 (Members)<br/>550,000 (non-members)</td>
      <td>200,000 (Members)<br/>300,000 (non-members)</td>			
    </tr>
    <tr>
      <th scope="row">3</th>
      <td>SUN</td>
      <td>450,000.00  (Members)<br/>550,000 (non-members)</td>
      <td>200,000 (Members)<br/>300,000 (non-members)</td>			
    </tr>
  </tbody>
</table>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default HallBookingRes
